module.exports = __webpack_public_path__ + "static/media/second.0fffa0e2.svg";